module.exports = __webpack_public_path__ + "static/media/plant-background.623ee553.svg";